import React, { useEffect, useRef, useState } from 'react'
import { useTheme } from '../../middleware/ThemeContext'
import styled from 'styled-components';
import { Container, Title, TitleGroup, TitleWrapper } from '../../components/listing/AMSListing';
import StyledText from '../../components/StyledComponents/StyledText';
import SecSettings from './SecSettings';
import SecLivePreview from './SecLivePreview';
import { useLocation, useNavigate } from 'react-router-dom';
import logoPlaceholder from '../../assets/images/logoPlaceholder.png'
import { time } from 'console';
import WebsiteConfigPopup from './WebsiteConfigPopup';
import { WebsiteFormValues } from '../../types/types';

const WebsiteBuilderDefaultTheme = () => {
    const { theme } = useTheme();
    const navigate = useNavigate();
    const location = useLocation();
    const tabsContainerRef = useRef<HTMLDivElement>(null);
    const [isResponsive, setIsResponsive] = useState(false);
    const [showConfigPopup, setShowConfigPopup] = useState(false);
    const shouldShowPopup = location?.state?.showConfigPopup || false;

    const [websiteDetails, setWebsiteDetails] = useState<WebsiteFormValues>({
        websiteName: '',
        websiteURl: '',
        timezone: '',
        logo: "",
        active: false,
        primaryColor: "#0050FF",
        secondaryColor: "#F59E0B",
        textColor: "#003366",
        fontFamily: "Poppins",
        logoPreview: "",
        loginDescription: '',
        loginHeading: '',
        logoFileName: '',
        logoFileSize: 0
    });

    useEffect(() => {
        // Show popup if navigation included the flag
        if (shouldShowPopup) {
            setTimeout(() => {
                setShowConfigPopup(true);
            }, 500);
        }
    }, [shouldShowPopup]);

    useEffect(() => {
        const container = tabsContainerRef.current;
        if (!container) return;

        // Create ResizeObserver
        const resizeObserver = new ResizeObserver((entries) => {
            for (let entry of entries) {
                const width = entry.contentRect.width;
                if (width <= 1350) {
                    setIsResponsive(true);
                } else {
                    setIsResponsive(false);
                }
            }
        });

        // Observe the container
        resizeObserver.observe(container);

        // Cleanup
        return () => {
            resizeObserver.unobserve(container);
            resizeObserver.disconnect();
        };
    }, []);


    return (
        <>
            <MainContent theme={theme} ref={tabsContainerRef}>
                <Container theme={theme} className='rounded-0'>
                    <div className="d-flex justify-content-between mt-0">
                        <div className="d-flex align-items-center gap-2">
                            <TitleGroup>
                                <TitleWrapper>
                                    <Title theme={theme}>Website Builder</Title>
                                </TitleWrapper>
                                <StyledText className='mt-2' fontSize="14px" fontWeight={300} textColor={theme.CorporateTheme.colors.textSecondary}>
                                    Create stunning website within minutes.
                                </StyledText>
                            </TitleGroup>
                        </div>
                    </div>
                </Container>
                <div className="container-fluid pt-3 pb-3"
                    style={{
                        height: 'calc(100vh - 137px)',
                        overflow: 'auto',
                        backgroundColor: theme.CorporateTheme.colors.bannerBg,
                    }}
                >
                    <div className='d-flex gap-3'>
                        <div style={{ width: 'calc( 100vw - 940px )' }}>
                            <SecSettings websiteDetails={websiteDetails} setWebsiteDetails={setWebsiteDetails} isResponsive={isResponsive} />
                        </div>
                        <div style={{ width: '100%', maxWidth: '520px' }}>
                            <SecLivePreview websiteDetails={websiteDetails} isResponsive={isResponsive} />
                        </div>
                    </div>
                </div>
            </MainContent>
            {/* ✅ Conditionally render popup based on state */}
            {showConfigPopup && (
                <WebsiteConfigPopup 
                    setWebsiteDetails={setWebsiteDetails} 
                    websiteDetails={websiteDetails}  
                    onClose={(shouldNavigateBack?: boolean) => {
                        setShowConfigPopup(false);
                        if (shouldNavigateBack) {
                            navigate(-1);
                        }
                    }} 
                />
            )}
        </>
    )
}

export default WebsiteBuilderDefaultTheme

const MainContent = styled.div<{ theme: any }>(({ theme }) => ({
    flexGrow: 1,
    backgroundColor: theme.colors.contentBackground,
    color: theme.colors.contentText,
    minWidth: '600px',
}));